import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_gu3jazsrse: FaireCollectionEntity = {
  token: "pbc_gu3jazsrse",
  type: "collection",
  name: "Dress Up Kits/Capes",
  heroImageUrl:
    "https://cdn.faire.com/fastly/42a570ee3271817442b038420fe7d9ed1c1bc12221428db4f89d640216b49bed.jpeg",
  itemCount: 20,
  description:
    "Girls are superheroes too! Sweet Wink dress-up capes, wands and accessories are designed for all the little girls that love to play pretend, dress up, and believe they are superheroes - because they are!",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:37.111Z",
    importedBy: "entity-db-import-collections",
  },
};
